import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertEventService} from './alert.event.service';
import {HttpModule} from '@angular/http';
import {NgPopAlertService} from './ng-pop-alert.service';
import {NgPopAlertComponent} from './ng-pop-alert.component';
import {ValidationErrorService} from './validation-error.service';
export class NgPopAlertModule {
/**
 * @return {?}
 */
static forRoot() {
    return {
      ngModule: NgPopAlertModule,
      providers: [NgPopAlertService, AlertEventService, ValidationErrorService]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpModule,
    CommonModule
  ],
  declarations: [NgPopAlertComponent],
  exports: [NgPopAlertComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgPopAlertModule_tsickle_Closure_declarations() {
/** @type {?} */
NgPopAlertModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPopAlertModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
